const site = "在线吃瓜";

const footerLinks: { title: string; links: { label: string; href: string }[] }[] = [
  {
    title: "浏览栏目",
    links: [
      { label: "热点复盘", href: "#hot" },
      { label: "完整时间线", href: "#timeline" },
      { label: "前因后果解析", href: "#method" },
      { label: "深度内容", href: "#media" },
    ],
  },
  {
    title: "了解我们",
    links: [
      { label: "关于在线吃瓜", href: "#about" },
      { label: "常见问题", href: "#faq" },
      { label: "投稿与线索", href: "#faq" },
      { label: "订阅推送", href: "#subscribe" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-200 border-t border-background-300">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid gap-10 lg:grid-cols-12">
          {/* 品牌 */}
          <div className="lg:col-span-5">
            <a href="#top" className="flex items-center gap-2.5" aria-label="回到首页">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-water-flash-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="flex flex-col">
                <span className="font-heading text-xl font-extrabold text-foreground-900">{site}</span>
                <span className="text-[10px] tracking-[0.2em] text-foreground-500">理清来龙去脉,看懂整场瓜</span>
              </span>
            </a>
            <p className="mt-5 max-w-sm text-sm text-foreground-600 leading-relaxed">
              以完整时间线还原事件始末,以前因后果解析交代背景,以深度复盘帮助你看清每一场舆论热点的完整脉络。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-weibo-line", "ri-bilibili-line", "ri-wechat-line", "ri-rss-line"].map((ic) => (
                <a
                  key={ic}
                  href="#top"
                  aria-label="社交媒体入口"
                  className="w-9 h-9 rounded-md bg-background-50 text-foreground-600 flex items-center justify-center hover:bg-secondary-100 hover:text-secondary-800 transition-colors"
                >
                  <i className={ic + " text-lg"} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          {/* 链接 */}
          {footerLinks.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <h4 className="font-heading text-sm font-bold text-foreground-900">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="inline-block text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* 联系方式 */}
          <div className="lg:col-span-3">
            <h4 className="font-heading text-sm font-bold text-foreground-900">投稿与联系</h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-primary-500" aria-hidden="true"></i>
                <span>hello@zaixianchigua.example</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-message-3-line mt-0.5 text-primary-500" aria-hidden="true"></i>
                <span>投稿线索请注明可核验出处</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5 text-primary-500" aria-hidden="true"></i>
                <span>内容均来自公开信息,尊重当事人权益</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 {site}. 本站内容仅作信息梳理与讨论,不构成任何立场或评价。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#top" className="hover:text-primary-600 whitespace-nowrap">回到顶部</a>
            <a href="#faq" className="hover:text-primary-600 whitespace-nowrap">网站说明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}